import { StepConfig } from 'components/new-ui/composed/multistep-form/types';
import { CreateJobFormSteps } from 'views/jobs/types';
import {
    assignAgentSectionValidationSchema,
    CreateJobFormFields,
    customerSectionValidationSchema,
    jobSectionValidationSchema,
    teamSectionValidationSchema,
    getDeliveryTermsSectionValidationSchema,
} from 'views/jobs/validationSchemas';
import JobSection from './JobSection';
import CustomerSection from './CustomerSection';
import DeliveryTermsSection from './DeliveryTermsSection';
import AssignAgentSection from './AssignAgentSection';
import TeamSection from './TeamSection';

type Props = {
    isFreightForwarder: boolean;
    isFreightAdmin: boolean;
    canAssignJobs: boolean;
    isUnderTeam: boolean;
};

// Note: If company type is Freight Forwarder, we can select a team
export const getStepsConfig = ({
    isFreightAdmin,
    isFreightForwarder,
    canAssignJobs,
    isUnderTeam,
}: Props): StepConfig<CreateJobFormFields>[] => {
    const steps: StepConfig<CreateJobFormFields>[] = [
        {
            key: CreateJobFormSteps.JOB,
            label: 'Job',
            validationSchema: jobSectionValidationSchema,
            component: JobSection,
            skipAutoProgress: true,
        },
        {
            key: CreateJobFormSteps.CUSTOMER,
            label: 'Customer',
            validationSchema: customerSectionValidationSchema,
            component: CustomerSection,
        },
    ];

    // DeliveryTerm section is required only for Freight Forwarder roles
    steps.push({
        optional: !isFreightForwarder,
        key: CreateJobFormSteps.DELIVERY_TERMS,
        label: isFreightForwarder ? 'Delivery Terms' : 'Delivery Terms (Optional)',
        validationSchema: getDeliveryTermsSectionValidationSchema(isFreightForwarder),
        component: DeliveryTermsSection,
    });

    // We show TeamSection only for Freight Admin
    if (isFreightAdmin && !isUnderTeam) {
        steps.push({
            key: CreateJobFormSteps.TEAM,
            label: 'Team',
            validationSchema: teamSectionValidationSchema,
            component: TeamSection,
        });
    }

    if (canAssignJobs) {
        steps.push({
            optional: true,
            key: CreateJobFormSteps.ASSIGN_AGENT,
            label: 'Assign Agent',
            validationSchema: assignAgentSectionValidationSchema,
            component: AssignAgentSection,
        });
    }

    return steps;
};
